import React, { useRef, useState } from 'react';
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

import MapPin from '../../../src/images/detailview/location_pin.svg';
import mapStyles from "../../../src/styles/map_styles.json";
import SvgIcon from "../../SharedComponents/Icons";

import './index.sass';


const Map = ({ address, coords, directionsLink, googleApiKey, staticMapUrl }) => {

  let mapRef = useRef();

  const [hovered, setHovered] = useState(false);

  const { latitude, longitude } = coords;
  const position = { lat: latitude, lng: longitude };
  const containerStyle = { width: "100%", height: "100%" };

  const handleHover = () => !hovered && setHovered(true);


  return (
    <div className="detail-view-map" id="detailsMap">
      <h2 className="detail-view__section-header">Beliggenhed</h2>

      { directionsLink &&
        <a className="detail-view-map__directions-link" href={directionsLink} target="_blank">
          <SvgIcon name="direction" size={24} /> Rutevejledning til adressen
        </a>
      }

      <p className="detail-view-map__address">{ address }</p>

      <div className="detail-view-map__map-wrapper" onMouseEnter={handleHover} onTouchStart={handleHover}>
        { !hovered &&
          <img alt="Location"
               className="detail-view-map__cover lazyload"
               data-expand="100"
               data-sizes="auto"
               data-src={staticMapUrl}
          />
        }

        { hovered &&
          <LoadScript googleMapsApiKey={googleApiKey}>
            <GoogleMap
              ref={(map) => mapRef = map}
              mapContainerStyle={containerStyle}
              mapContainerClassName="main-map"
              id="main-map"
              zoom={13}
              center={position}
              options={{
                scrollwheel: true,
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                gestureHandling: "greedy",
                styles: mapStyles,
              }}
            >
              <Marker
                icon={{ url: MapPin, scaledSize: { width: 64, height: 64 } }}
                key="markerKey"
                // noRedraw={true}
                // place_id={placeId || null}
                position={position}
              >
              </Marker>
            </GoogleMap>
          </LoadScript>
        }
      </div>
    </div>
  )
}

export default Map;
